import React from "react";
import Button, { ButtonProps } from "./ui/button";

type Props = Omit<ButtonProps, "visualState">;

const ActiveFakeButton = React.forwardRef<HTMLButtonElement, Props>(
  (props, ref) => {
    return <Button ref={ref} visualState="active" type="button" {...props} />;
  }
);
ActiveFakeButton.displayName = "ActiveFakeButton";

export default ActiveFakeButton;
